// extracted by mini-css-extract-plugin
export default {"languageDropdown":"_3_FC-","controlIcon":"_3LhDJ","menuItemIcon":"_3V78c","menuItemLabel":"_2RqRi"};